var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpiringSoonDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8327_2334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_8327_2334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5227 8.20803L14.7227 6.40803C14.6627 6.34803 14.5787 6.31201 14.4827 6.31201H9.38266C9.19067 6.31201 9.04665 6.46803 9.04665 6.64803V7.96803H7.72665C7.53466 7.96803 7.39062 8.12405 7.39062 8.30405V17.3641C7.39062 17.556 7.54665 17.7001 7.72665 17.7001H14.6266C14.8186 17.7001 14.9627 17.5441 14.9627 17.3641V16.0441H16.2827C16.4747 16.0441 16.6187 15.888 16.6187 15.708V8.44803C16.6187 8.35202 16.5827 8.26803 16.5227 8.20803ZM15.8027 8.44803H14.4707V7.11603L15.8027 8.44803ZM14.2787 17.028H8.05066V8.64003H9.03464V15.708C9.03464 15.9 9.19067 16.044 9.37067 16.044L14.2787 16.044V17.028ZM9.71866 15.36V6.97203H13.7867V8.78403C13.7867 8.97602 13.9427 9.12005 14.1227 9.12005H15.9347V15.36L9.71866 15.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5205 13.5122H11.1485C10.9565 13.5122 10.8125 13.6682 10.8125 13.8482C10.8125 14.0402 10.9685 14.1842 11.1485 14.1842L14.5205 14.1842C14.7125 14.1842 14.8565 14.0282 14.8565 13.8482C14.8565 13.6562 14.7005 13.5122 14.5205 13.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5205 11.8198H11.1485C10.9565 11.8198 10.8125 11.9758 10.8125 12.1558C10.8125 12.3358 10.9685 12.4919 11.1485 12.4919L14.5205 12.4918C14.7125 12.4918 14.8565 12.3358 14.8565 12.1558C14.8565 11.9758 14.7005 11.8198 14.5205 11.8198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5205 10.1401H11.1485C10.9565 10.1401 10.8125 10.2962 10.8125 10.4762C10.8125 10.6562 10.9685 10.8122 11.1485 10.8122L14.5205 10.8121C14.7125 10.8121 14.8565 10.6561 14.8565 10.4761C14.8565 10.2962 14.7005 10.1401 14.5205 10.1401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1485 9.132H12.5285C12.7205 9.132 12.8645 8.97598 12.8645 8.79598C12.8645 8.60399 12.7085 8.45996 12.5285 8.45996L11.1485 8.46C10.9565 8.46 10.8125 8.61602 10.8125 8.79602C10.8125 8.97602 10.9565 9.132 11.1485 9.132Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8327_2334",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187DB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8327_2334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiringSoonDocuments);
export default __webpack_public_path__ + "static/media/expiring_soon_documents.8a08e283cc656e679deafaf786ae9271.svg";
export { ForwardRef as ReactComponent };